import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const NOTIFICATIONS = [
  {
    id: 1,
    title: "Submission approval",
    date: "May 23, 2024",
    description:
      "Your submission for Olugbenga Akintola vs Israel Anyemalu has been reviewed and approved.",
  },
  {
    id: 2,
    title: "Submission approval",
    date: "May 23, 2024",
    description:
      "Your submission for Olugbenga Akintola vs Israel Anyemalu has been reviewed and approved.",
  },
];

function Notifications() {
  return (
    <div className="flex flex-col h-full min-h-screen">
      {/* Header */}
      <div className="px-8 py-6 border-b border-[#E9EAEB]">
        <h1 className="text-[28px] font-bold text-[#1A1A1A]">Notifications</h1>
      </div>

      {/* Breadcrumbs */}
      <div className="px-8 py-4 flex items-center gap-x-2 text-sm">
        <Link
          to="/lawyer/overview"
          className="text-[#98A2B3] hover:text-[#1A1A1A] transition-colors"
        >
          Home
        </Link>
        <ChevronRight className="w-4 h-4 text-[#98A2B3]" />
        <span className="font-medium text-[#1A1A1A]">Notifications</span>
      </div>

      {/* Content */}
      <div className="flex-1  px-8 py-6">
        <div className="flex flex-col gap-y-4">
          {NOTIFICATIONS.map((notification) => (
            <div
              key={notification.id}
              className="bg-white p-6 rounded-xl shadow-boxShadow flex flex-col gap-y-2"
            >
              <div className="flex items-center justify-between">
                <h3 className="text-base font-bold text-[#4D4D4D]">
                  {notification.title}
                </h3>
                <span className="text-sm text-[#9A9A9A] font-medium">
                  {notification.date}
                </span>
              </div>
              <p className="text-sm text-[#9A9A9A] font-medium">
                {notification.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Notifications;
